import { PharmacyMark } from './ui/PharmacyMark'

export interface AuthHeroProps {
  title: string
  subtitle: string
  withLogo?: boolean
}

export function AuthHero({ title, subtitle, withLogo = false }: AuthHeroProps) {
  return (
    <header className="auth-hero">
      {withLogo ? <PharmacyMark /> : null}
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </header>
  )
}
